import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: () => import('./views/Schedule.vue'),
    },
    {
      path: '/directions',
      name: 'directions',
      component: () => import('./views/Directions.vue'),
    },
    {
      path: '/travel',
      name: 'travel',
      component: () => import('./views/Travel.vue'),
    },
    {
      path: '/photos',
      name: 'photos',
      component: () => import('./views/Photos.vue'),
    },
    {
      path: '/photos/:photoId',
      name: 'photos-details',
      props: true,
      component: () => import('./views/PhotoDetails.vue'),
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('./views/FAQ.vue'),
    },
    {
      path: '/registry',
      name: 'registry',
      component: () => import('./views/Registry.vue'),
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact.vue'),
    },
    {
      path: '/rsvp',
      name: 'rsvp',
      component: () => import('./views/RSVP.vue'),
    },
    {
      path: '/rsvp-submit',
      name: 'rsvp-submit',
      component: () => import('./views/RSVP-Submit.vue'),
    },
    {
      path: '/china',
      name: 'china',
      component: () => import('./views/China.vue'),
    },
    // Finally, if no other match is found return error page
    {
      path: '*',
      name: 'error',
      component: () => import('./views/ErrorPage.vue'),
    },
  ],
});
